import ManageCommentaire from '@/views/consultations/en-cours/consultation-commentaire/manage-consultation-commentaire'
// import { getFormattedDateTime } from '@/utils/datetime';

export default {
    name: 'consultation-commentaire',
    components: {
        ManageCommentaire
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        slug: String,
        current_consultation_evolution: Number,
        is_start: Number
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,

            comment_selected: {},
            filename: '',
            font_size: 'font-14',
        }
    },

    watch: {
        evolution_toggler() {
            this.refreshCommentaire()   // Consultation commmentaires

            this.$store.commit("SET_CAN_PRINT_COMMENT", false)
            this.$store.commit("SET_COMMENT_TO_PRINT", {})
        }
    },

    computed: {
        consultation_commentaires() {
            return this.$store.getters["consultation_commentaires"]
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        patient(){
            return this.$store.getters['patient'];
        },
    },

    mounted() {
        
    },

    methods: {
        refreshCommentaire() {
            this.is_loading = true 

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                data_type: this.slug,
                est_encours: true
            }
            this.$store.dispatch('getConsultationInfoComplementaire', data).then(() => {
                if (this.consultation_commentaires.length > 0) {
                    this.is_empty = false

                    for(let i = 0; i < this.consultation_commentaires.length; i++) {
                        let content = this.consultation_commentaires[i].content
                        content = content.replace("[DROITE]", "<div class=\"w-100 algn-right\">")
                        content = content.replace("[/DROITE]", "</div>")
                        this.consultation_commentaires[i].content = content
                    }
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        addNewComment() {
            this.comment_selected = {
                modal_title: this.section_name
            }
        },

        setCommentToEdit(comment) {
            this.comment_selected = comment
            this.comment_selected.modal_title = this.section_name
        },

        printComment(comment) {
            this.$store.commit("SET_CAN_PRINT_COMMENT", true)
            this.$store.commit("SET_COMMENT_TO_PRINT", comment)
        },

        // getFormattedDateTime(datetime) {
        //     return moment(datetime).format('[le] DD/MM/YYYY [à] HH[h]mm');
        // },

        preview(comment) {
            this.comment_selected = comment
            this.$refs['preview-comment-modal'].show()
        },

        closeCommentPreview() {
            this.$refs['preview-comment-modal'].hide()
        },
    }
}


